import styled from '@emotion/styled';
import { useMemo } from 'react';
import { Box, breakpoints, DisplayCard, Flex, FrontButton, themeVars } from 'src/ui-components';
import { ChartIcon, TableIcon } from 'src/ui-components/icons';

import { SparklineView } from './components/SparklineView';
import { TableView } from './components/TableView';
import type { ITopProductsTab } from './store/store';
import { topProductsActions, useTopProductsStore } from './store/store';

export const TopProducts = () => {
  const { view, tab } = useTopProductsStore();

  const title = useMemo(
    () => (tab === 'desc' ? 'Top Performing Products' : 'Product Performance'),
    [tab],
  );

  return (
    <Wrapper title={title} actions={<Actions />}>
      <Box style={{ overflow: 'hidden' }}>
        {view === 'sparkline' ? (
          <SparklineView key={'SparklineView'} />
        ) : (
          <TableView key={'TableView'} />
        )}
      </Box>
    </Wrapper>
  );
};

const Actions = () => {
  const { tab, view } = useTopProductsStore();
  return (
    <Flex gap={'8px'}>
      {/*<SegmentedControl data={tabs} value={tab} onChange={topProductsActions.setTab} />*/}
      <FrontButton isIcon variant="tertiary" size={'xs'} onClick={topProductsActions.switchView}>
        {view === 'sparkline' ? (
          <TableIcon color={themeVars.colors.titan600} />
        ) : (
          <ChartIcon color={themeVars.colors.titan600} />
        )}
      </FrontButton>
    </Flex>
  );
};

const tabs: { value: ITopProductsTab; label: string }[] = [
  {
    value: 'desc',
    label: 'Top Performers',
  },
  // {
  //   value: 'asc',
  //   label: 'Growth Opportunities',
  // },
];

const Wrapper = styled(DisplayCard)`
  grid-column: 1 / 3;
  overflow: hidden;

  ${breakpoints.before.desktop} {
    grid-column: 1 / 1;
  }
`;
